export default __webpack_public_path__ + "static/media/loading.940bbc46.gif";